module.exports = __webpack_public_path__ + "static/media/quiz.b455776f.svg";